<div class="dropdown__list">
  <ng-content></ng-content>
</div>
